import ReactApexChart from "react-apexcharts";
import getChartColorsArray from "../../../../Components/Common/ChartsDynamicColor";

const DailyOrdersChart = ({ dailyData, dataColors }) => {
  var chartColumnDistributedColors = getChartColorsArray(dataColors);

  const series = [
    {
      name: "Total Orders",
      data: dailyData?.map((day) => ({
        x: day?.date,
        y: day?.total_orders,
      })),
    },
  ];

  var options = {
    chart: {
      height: 350,
      type: "bar",
      toolbar: {
        show: false,
      },
    },
    colors: chartColumnDistributedColors,
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "45%",
      },
    },
    dataLabels: {
      enabled: true,
    },
    legend: {
      show: false,
    },
    xaxis: {
      type: "category",
      labels: {
        rotate: -45,
      },
    },
    title: {
      text: "Daily Orders",
      style: {
        fontWeight: 500,
      },
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val + " orders";
        },
      },
    },
  };

  return (
    <ReactApexChart
      dir="ltr"
      className="apex-charts"
      series={series}
      options={options}
      type="bar"
      height={350}
    />
  );
};

const DailyDeliveryTimeChart = ({ dailyData, dataColors }) => {
  const chartColors = getChartColorsArray(dataColors);

  const categories = dailyData?.map((day) => day.date) || [];

  const formatSecondsToMinSec = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = Math.round(seconds % 60);
    return `${m}m ${s}s`;
  };

  const series = [
    {
      name: "Min Delivery Time",
      data: dailyData?.map((day) => day.min_delivery_time) || [],
    },
    {
      name: "Avg Delivery Time",
      data: dailyData?.map((day) => day.avg_delivery_time) || [],
    },
    {
      name: "Max Delivery Time",
      data: dailyData?.map((day) => day.max_delivery_time) || [],
    },
  ];

  const options = {
    chart: {
      height: 350,
      type: "bar",
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "45%",
        endingShape: "rounded",
      },
    },
    colors: chartColors,
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return Number(val / 60).toFixed(0);
      },
    },
    xaxis: {
      categories: categories,
      labels: {
        rotate: -45,
      },
    },
    yaxis: {
      title: {
        text: "Delivery Time (minutes)",
      },
      labels: {
        formatter: function (val) {
          const totalSeconds = Math.round(val);
          const h = Math.floor(totalSeconds / 3600);
          const m = Math.floor((totalSeconds % 3600) / 60);
          const s = totalSeconds % 60;

          if (h > 0) return `${h}h ${m}m`;
          if (m > 0) return `${m}m ${s}s`;
          return `${s}s`;
        },
      },
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return formatSecondsToMinSec(val);
        },
      },
    },
    title: {
      text: "Daily Delivery Times",
      style: {
        fontWeight: 500,
      },
    },
  };

  return (
    <ReactApexChart
      dir="ltr"
      className="apex-charts"
      series={series}
      options={options}
      type="bar"
      height={350}
    />
  );
};

const ItemOrdersCandleChart = ({ itemData, dataColors }) => {
  const chartColors = getChartColorsArray(dataColors);

  const series = [
    {
      name: "Orders",
      data: itemData?.map((item) => ({
        x: item?.item_name,
        y: item?.order_count,
      })),
    },
  ];

  const options = {
    chart: {
      height: 500,
      type: "bar",
      toolbar: {
        show: false,
      },
    },
    colors: chartColors,
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: "80%",
        dataLabels: {
          position: "center",
        },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return val + " orders";
      },
    },
    legend: {
      show: false,
    },
    xaxis: {
      type: "numeric",
      title: {
        text: "Number of Orders",
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: "12px",
        },
      },
    },
    title: {
      text: "Item Order Count",
      style: {
        fontWeight: 500,
      },
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val + " orders";
        },
      },
    },
  };

  return (
    <ReactApexChart
      dir="ltr"
      className="apex-charts"
      series={series}
      options={options}
      type="bar"
      height={500}
    />
  );
};

export { DailyOrdersChart, DailyDeliveryTimeChart, ItemOrdersCandleChart };
